(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["stock-confirmation-popup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('stock-confirmation')) {
    customElements.define(
      'stock-confirmation',
      class StockConfirmation extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.message = this.querySelector('[data-stock-message]');
          this.form = document.getElementById(this.dataset.formId);
          this.submitButton = this.form?.querySelector('[type="submit"][name="add"]');
          this.variants = JSON.parse(this.querySelector('[data-stock-variants]').textContent);
          this.messages = JSON.parse(this.querySelector('[data-stock-messages]').textContent);
          this.skipNextSubmit = false;
          this.skipNextClick = false;
          this.pendingSubmitter = null;
          this.pendingAction = 'submit';
          this.availableQuantity = 0;

          if (!this.form || !this.dialog) return;

          this.onSubmit = this.handleSubmit.bind(this);
          this.onButtonClick = this.handleButtonClick.bind(this);
          this.onDialogClick = this.handleDialogClick.bind(this);
          this.onConfirm = this.handleConfirm.bind(this);
          this.onCancel = this.handleCancel.bind(this);
          this.onCartUpdate = this.handleCartUpdate.bind(this);

          this.form.addEventListener('submit', this.onSubmit, true);
          this.submitButton?.addEventListener('click', this.onButtonClick, true);
          this.dialog.addEventListener('click', this.onDialogClick);
          this.querySelector('[data-stock-confirm]').addEventListener('click', this.onConfirm);
          this.querySelectorAll('[data-stock-cancel]').forEach((button) => button.addEventListener('click', this.onCancel));
          if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
            this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate);
          }
        }

        disconnectedCallback() {
          this.form?.removeEventListener('submit', this.onSubmit, true);
          this.submitButton?.removeEventListener('click', this.onButtonClick, true);
          this.dialog?.removeEventListener('click', this.onDialogClick);
          this.querySelector('[data-stock-confirm]')?.removeEventListener('click', this.onConfirm);
          this.querySelectorAll('[data-stock-cancel]').forEach((button) => button.removeEventListener('click', this.onCancel));
          this.cartUpdateUnsubscriber?.();
        }

        handleSubmit(event) {
          if (this.skipNextSubmit) {
            this.skipNextSubmit = false;
            return;
          }

          this.interceptStockLimit(event, 'submit');
        }

        handleButtonClick(event) {
          if (this.skipNextClick) {
            this.skipNextClick = false;
            return;
          }

          this.interceptStockLimit(event, 'click');
        }

        interceptStockLimit(event, action) {
          if (this.dialog.open) return;

          const formData = new FormData(this.form);
          const variantId = Number(formData.get('id'));
          const requestedQuantity = Math.max(1, Number(formData.get('quantity')) || 1);
          const variant = this.variants.find((item) => Number(item.id) === variantId);

          if (!variant || variant.inventory_management !== 'shopify' || variant.inventory_policy !== 'deny') return;

          const availableQuantity = Math.max(0, Number(variant.inventory_quantity) || 0);
          if (requestedQuantity <= availableQuantity) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          this.pendingSubmitter = event.submitter;
          this.pendingAction = action;
          this.availableQuantity = availableQuantity;
          this.message.textContent = this.buildMessage(availableQuantity, requestedQuantity);
          this.dialog.showModal();
        }

        buildMessage(availableQuantity, requestedQuantity) {
          return this.messages.limited_stock
            .replace('[available]', availableQuantity)
            .replace('[requested]', requestedQuantity);
        }

        handleConfirm() {
          const quantityInput = this.form.elements.namedItem('quantity');
          if (!quantityInput || this.availableQuantity < 1) {
            this.handleCancel();
            return;
          }

          quantityInput.value = this.availableQuantity;
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
          this.dialog.close();

          if (this.pendingAction === 'click' && this.submitButton) {
            this.skipNextClick = true;
            this.submitButton.click();
          } else {
            this.skipNextSubmit = true;
            this.form.requestSubmit(this.pendingSubmitter || undefined);
          }
        }

        handleCancel() {
          this.dialog.close();
          this.form.querySelector('[type="submit"]')?.focus();
        }

        handleCartUpdate(event) {
          const sectionHtml = event?.data?.cartData?.sections?.['cart-icon-bubble'];
          const basketLink = document.getElementById('cart-icon-bubble');
          if (!sectionHtml || !basketLink) return;

          const parsedHtml = new DOMParser().parseFromString(sectionHtml, 'text/html');
          const renderedSection = parsedHtml.querySelector('.shopify-section');
          if (!renderedSection) return;

          basketLink.innerHTML = renderedSection.innerHTML;
        }

        handleDialogClick(event) {
          if (event.target === this.dialog) this.handleCancel();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
